import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, URLKEY } from '../services/auth.service';

export const IsLoggedGuardService: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);

  const url = state.url;
  sessionStorage.setItem(URLKEY, url);

  return new Observable<boolean>((observer) => {
    if (authService.isLoggedIn()) {
      authService.loadUser().subscribe(() => {
        observer.next(true);
        observer.complete();
      });
    } else {
      authService.startAuthentication(url);
    }
  });
};
